import { z } from 'zod';
import { Id, IsoDateTime } from './common.js';
import { ChannelType } from './channels.js';

export const Customer = z.object({
  customer_id: Id,
  merchant_id: Id,
  phone: z.string().nullable(),
  name: z.string().nullable(),
  email: z.string().nullable(),
  address: z.string().nullable(),
  tags: z.array(z.string()).default([]),
  notes: z.string().default(''),
  first_contact_at: IsoDateTime,
  last_contact_at: IsoDateTime,
  total_conversations: z.number().int().nonnegative().default(0),
  total_orders: z.number().int().nonnegative().default(0),
  total_appointments: z.number().int().nonnegative().default(0),
  lifetime_value_cents: z.number().int().nonnegative().default(0),
  no_show_count: z.number().int().nonnegative().default(0),
});
export type Customer = z.infer<typeof Customer>;

export const ChannelIdentity = z.object({
  identity_id: Id,
  customer_id: Id,
  merchant_id: Id,
  channel_id: Id,
  channel_type: ChannelType,
  external_user_id: z.string(),
  display_name: z.string().nullable().optional(),
});

export const LeadStatus = z.enum(['new', 'contacted', 'qualified', 'converted', 'lost']);
export type LeadStatus = z.infer<typeof LeadStatus>;

export const LeadType = z.enum(['interest', 'callback', 'quote', 'support']);

export const Lead = z.object({
  lead_id: Id,
  merchant_id: Id,
  customer_id: Id.nullable(),
  phone: z.string().nullable(),
  name: z.string().nullable(),
  email: z.string().nullable(),
  lead_type: LeadType.default('interest'),
  service_of_interest: Id.nullable(),
  product_of_interest: Id.nullable(),
  requirement_notes: z.string().default(''),
  urgency: z.enum(['low', 'medium', 'high']).default('medium'),
  budget_range: z.string().nullable(),
  source_channel: ChannelType.nullable(),
  source_conversation_id: Id.nullable(),
  status: LeadStatus.default('new'),
  assigned_to_user_id: Id.nullable(),
  tags: z.array(z.string()).default([]),
  notes: z.string().default(''),
  follow_up_at: IsoDateTime.nullable(),
  created_at: IsoDateTime,
  last_updated_at: IsoDateTime,
});
export type Lead = z.infer<typeof Lead>;
